import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import Icon from '@/app/components/Icon';
import Text from '@/app/components/Text';
import SearchInput from './SearchInput';
import CartMenu from '../../Input/CartMenu';

function SearchAndCart() {
  const { items: cart } = useSelector((state) => state.carts);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  return (
    <div
      className={cn(
        'flex justify-start lg:justify-end items-center gap-[14px] xl:gap-[20px] sm:pt-0 lg:pb-12 sm:pb-0',
        {
          'gap-[24px]': isSearchActive,
        },
      )}
    >
      <SearchInput />
      <CartMenu />

      <div
        className={cn(
          'w-[48px] h-56 pr-0 sm:pr-8 flex lg:hidden justify-end items-center cursor-pointer',
          {
            '!hidden': isSearchActive,
          },
        )}
      >
        <Icon
          type="search"
          color="#fff"
          onClick={() => {
            setIsSearchActive(!isSearchActive);
          }}
        />
      </div>

      <div className="size-[24px] lg:size-[40px] flex lg:hidden justify-end lg:justify-center items-center p-8 cursor-pointer relative">
        <Icon type="cart" color="#fff" className="size-[24px]" />
        {isMounted && cart?.length > 0 ? (
          <Text
            type="span"
            className="bg-richcarmine w-[24px] h-[24px] flex justify-center items-center text-sm text-white font-semibold px-4 py-2 rounded-full absolute top-1 right-2"
          >
            {cart?.length}
          </Text>
        ) : null}
      </div>
    </div>
  );
}

export default SearchAndCart;
